/** Pure translation lookup with {name} interpolation */

import { en, type Dictionary, type TranslationKey } from './en'
import { vi } from './vi'
import type { Locale } from './locale'

export const dictionaries: Record<Locale, Dictionary> = { en, vi }

export type TranslationParams = Record<string, string | number>

export type TranslateFn = (key: TranslationKey, params?: TranslationParams) => string

/** Replace {name} placeholders; unknown placeholders are left untouched so gaps stay visible */
export function interpolate(template: string, params?: TranslationParams): string {
  if (!params) return template
  return template.replace(/\{(\w+)\}/g, (match, name: string) =>
    Object.prototype.hasOwnProperty.call(params, name) ? String(params[name]) : match,
  )
}

export function translate(locale: Locale, key: TranslationKey, params?: TranslationParams): string {
  const template = dictionaries[locale][key] ?? en[key] ?? key
  return interpolate(template, params)
}
